var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHouseIcon = function SvgHouseIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.005.384a1.49 1.49 0 0 1 2 0L31.5 13.386c.619.55.669 1.5.113 2.119-.556.618-1.5.668-2.119.112l-.5-.45V28c0 2.206-1.793 4-3.998 4H7a4.003 4.003 0 0 1-3.999-4V15.167l-.5.45c-.618.55-1.562.5-2.118-.112a1.5 1.5 0 0 1 .113-2.12zm1 3.132-9.997 8.97v15.52c0 .55.45 1 1 1h2.999v-6.5c0-2.488 2.012-4.501 4.499-4.501h2.999a4.497 4.497 0 0 1 4.499 4.5v6.501h2.999c.55 0 1-.45 1-1v-15.52l-9.998-8.964zm-3 25.49h6v-6.5c0-.832-.67-1.5-1.5-1.5h-3c-.83 0-1.5.668-1.5 1.5z"
  })));
};
export default SvgHouseIcon;